import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { FaLinkedin } from 'react-icons/fa';

const FundInFocusMarch2025: React.FC = () => (
  <>
    {/* members */}
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height={{ xs: '450px', sm: '300px' }}
      minH={{ xs: '450px', sm: '300px' }}
      maxH="450px"
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/jpg/blogBanner.jpg"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Heading
          as="h1"
          mb="20px"
          variant="reportCardTitle"
          fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
          color="white"
          lineHeight={{ xs: '34px', md: '39px', lg: '42px' }}
        >
          Fund In Focus: Inside WEH Ventures' Playbook: India-First Ideas and
          Founder-Market Fit
        </Heading>
        <Text
          fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
          fontWeight="600"
          color="white"
          lineHeight="21px"
        >
          Deepak Gupta, Partner,
          <Link
            href="https://www.wehventures.com/"
            target="_blank"
            rel="noreferrer"
          >
            WEH Ventures
          </Link>
        </Text>
      </Container>
    </Flex>
    <Container
      as="section"
      maxW="container.xl"
      pb="80px"
      pt="40px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Box as="main" w="100%" pb="40px">
        <Text variant="blogAnswer">
          Welcome to our ‘Fund in Focus’ series where we profile our member VC
          funds, underscore their investment philosophy, and highlight some of
          their interesting work. In this exclusive chat with Deepak Gupta,
          Partner, WEH Ventures. The fund has been backing bold, uniquely Indian
          ideas since 2017—prioritizing founder-market fit, originality, and
          long-term value over conventional credentials. In this candid
          conversation, the team shares their investment approach, from spotting
          “emerging founders” to supporting startups serving Bharat’s next
          billion users. With a sharp focus on product-market fit, hands-on
          support, and sector-agnostic curiosity, WEH Ventures continues to
          shape early-stage success stories across India’s evolving startup
          landscape.
        </Text>
      </Box>

      <Img
        src="https://static.levocdn.com/WGLBUT82/DeepakGuptaPartnerWEHVentures-74doGDEvibaG2.jpg"
        alt="Perl"
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '40px', lg: '60px', xl: '70px' }}
        mb="20px"
        objectFit="contain"
      />
      <Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson: Deepak Gupta, Partner,
            <Link
              href="https://www.wehventures.com/"
              target="_blank"
              rel="noreferrer"
            >
              WEH Ventures
            </Link>
          </Heading>
          <Flex
            columnGap={{ xs: '4px', md: '16px' }}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            transform={{ xs: 'translateX(12px)', md: 'none' }}
          >
            <Box alignSelf="start" mt="5px">
              <Link
                href="https://www.linkedin.com/in/deepakgupta8/?originalSubdomain=in"
                target="_blank"
              >
                <IconButton
                  aria-label="linkedin"
                  icon={
                    <FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
        <Box
          ml={{ xs: 'auto', md: '345px', lg: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />
        <Box>
          <Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
            1. WEH Ventures has been backing early-stage startups since 2017.
            How has your investment philosophy evolved over the years?
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            Our philosophy has not changed that much. Over time we have better
            realization of what we are actually thinking and what we tend to
            like. E.g. We have frequently backed what we refer to as “Emerging
            Founders”- founders who are somewhat seasoned, have some startup
            experience (median experience of ~5 years) but not tasted big
            success and still quite hungry. Also we have backed models that may
            be somewhat unique to India and not adapted from successes elsewhere
            e.g. Jar (Gold based savings is not native to many countries),
            Animall (small holding farmers need help with livestock buy/sell),
            Masterchow (Chinese is a major food genre in India, and premiumizing
            with our desi twist).
          </Text>
        </Box>

        {/* Question 2 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            2. You’ve mentioned that WEH Ventures doesn’t rely on conventional
            checklists like IIT/IIM backgrounds or unicorn alumni status. What
            are some unconventional indicators that tell you a founder is worth
            backing?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              We look for founder match with the problem statement, superior
              insight, drive, execution agility and chemistry with us among
              other things. On some occasions one may just “fall off the chair”
              and that’s a good reason to back a company.
            </Text>
          </Box>
        </Box>
        {/* Ques 3 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            3. Many of your portfolio companies cater to Bharat’s next billion
            users. How do you evaluate the scalability of businesses targeting
            this segment?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              This segment is digitally savvy and moving from trying out to
              paying for things. We see that in the consistent and growing
              paying user base at Pratilipi or the sticky cohorts of gold buyers
              in Jar. Given the 800M+ internet penetration in India and growing
              propensity to consume and pay digitally, more and more ground-up
              uniquely made for India ideas become feasible to hit deep scale
              and large valuations.
            </Text>
          </Box>
        </Box>

        {/* Question 4 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            4. Your recent investment in MedMitra AI highlights your interest in
            health tech. Are there any specific sectors or trends you are
            particularly bullish on in 2024-25?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              We are sector agnostic- we started many years ago with more of a
              consumer bent. We have organically sectors such a climate,
              agri-tech, B2B marketplaces, hardware. And yes health is a sector
              where we are more focused recently and want to get more exposure.
            </Text>
          </Box>
        </Box>

        {/* Question 5 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            5. Capital allocation is a crucial part of startup success. How do
            you guide founders in managing their runway and fundraising
            strategy?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              At the base case, we believe and counsel founders that they should
              not waste capital in very early product scaling until they have
              convincing Product Market Fit. Many a growth curve has been built
              without the product actually demonstrating a clear value
              proposition. So validating the problem, what the company is aiming
              to be, validity of PMF, what milestones to hit for next raise and
              ensuring the runway management to land there fits the bill. We
              have enjoyed a very strong graduation rate of our companies to
              substantial follow on funding, They have raised over 2500cr nearly
              30x of what we have invested- so far.
            </Text>
          </Box>
        </Box>

        {/* Question 6 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            6. Your team also helps with hiring, business direction, and M&A
            activities. Can you share an example of a time when WEH Ventures
            played a pivotal role in shaping a portfolio company’s growth
            trajectory?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              We actively work with companies in improving their chances of
              success from the pre-seed to Series A stage. For instance, in the
              case of Masterchow, we invested in the company when they were
              doing 5l/month in revenue and we guided them on their early
              marketing strategies, helped make a business plan, interviewed
              early candidates and also connected them to Surge which ended up
              leading their Series A round. In another instance, when the
              founders decided to pivot their business, we met them every
              fortnight for 2 months and brainstormed multiple possible paths
              that leveraged the team’s strength while also aligning with the
              market opportunities. We also got them to validate their finalized
              path with an external expert before launch. We act as a sounding
              board without making judgments- founders know that we are on their
              side and treat us as true partners at the early-stage.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            7. What’s next for WEH Ventures? Are there any plans to expand your
            fund size or explore new investment themes?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              We will continue to scale our AUM in logical steps and explore
              newer themes from time to time. No specifics to add at this time.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            8. What advice would you give to first-time founders looking to
            raise seed capital in today’s investment climate?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              The number of early stage and micro-Vcs has grown substantially in
              recent years and they are quite active. So there are good chances
              for raising funding for strong ideas and teams (even for first
              time founders). They need to have a strong idea, narrative,
              founder team, execution and hustle - and they will get somewhere.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            9. What are your expectations for India’s startup ecosystem in 2025
            and beyond?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              The vibrancy continues to increase and we are seeing success going
              to startups from tier 2 cities and beyond. And the opportunity for
              “Made for India” propositions will deepen. The next few years seem
              to be promising.
            </Text>
          </Box>
        </Box>
      </Box>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default FundInFocusMarch2025;
